export default __webpack_public_path__ + "static/pragicts-ai-finance-6c6f234b51b0288e48ebb7436e4e86bd.jpg";